import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const downloadAllStoresReport = async ({
	formId,
	startDate,
	endDate
}: ExportCSVOptions) => {
	const url = "/observations/reports/all-stores";

	const data = { form_id: formId, startDate, endDate };

	const response = await cmsClient.post(url, data);
	return response.data;
};

const useAllStoresReport = () => {
	const onSuccess = () => {
		toast.success(
			<CustomToast
				type="Success"
				message="A link to your export (All Stores) has been generated. Check your mail inbox for the link."
			/>,
			{ hideProgressBar: true }
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(downloadAllStoresReport, { onSuccess, onError });
	return mutation;
};

export default useAllStoresReport;
